import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Opens a record that another page linked to with ?view=<id> (e.g. a document number clicked in a
 * report). `open(id)` is the page's own view action; the parameter is then removed from the address,
 * so closing the view and refreshing do not open it again.
 */
const useOpenFromQuery = (open, param = 'view') => {
  const location = useLocation();
  const navigate = useNavigate();
  const openRef = useRef(open);
  openRef.current = open;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get(param);
    if (!id) return;
    openRef.current(id);
    params.delete(param);
    navigate({ pathname: location.pathname, search: params.toString() ? `?${params}` : '' }, { replace: true });
  }, [location.search, location.pathname, navigate, param]);
};

export default useOpenFromQuery;
